var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34678",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7169 9.7922C15.7169 13.7781 12.4223 17.0074 8.35566 17.0074C4.28907 17.0074 1 13.7781 1 9.7922C1 5.80632 4.29467 2.58252 8.36126 2.58252",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5488 0.992676V6.58981",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.8438 3.79102H17.2537",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.796 10.8989C11.089 10.8989 11.2828 11.2132 11.1747 11.5036C10.7284 12.6845 9.63305 13.5177 8.35739 13.5177C7.08173 13.5177 5.98637 12.6845 5.54012 11.5036C5.43193 11.2179 5.62576 10.8989 5.91876 10.8989H10.8005H10.796Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 34676"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.1135 8.79369C6.63786 8.79369 7.06294 8.35391 7.06294 7.8114C7.06294 7.26889 6.63786 6.8291 6.1135 6.8291C5.58914 6.8291 5.16406 7.26889 5.16406 7.8114C5.16406 8.35391 5.58914 8.79369 6.1135 8.79369Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.6057 8.79369C11.1301 8.79369 11.5551 8.35391 11.5551 7.8114C11.5551 7.26889 11.1301 6.8291 10.6057 6.8291C10.0813 6.8291 9.65625 7.26889 9.65625 7.8114C9.65625 8.35391 10.0813 8.79369 10.6057 8.79369Z",
    fill: "#1A1A1A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetEmoji);
export default __webpack_public_path__ + "static/media/pet-emoji.0eb0af3e.svg";
export { ForwardRef as ReactComponent };